import React, { useState } from 'react';
import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import { client } from '../../client';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Footer.scss';

const Footer = () => {
	const [formData, setFormData] = useState({
		name: '',
		email: '',
		message: '',
	});
	const [isFormSubmitted, setIsFormSubmitted] = useState(false);
	const [loading, setLoading] = useState(false);

	const { name, email, message } = formData;

	const validateForm = () => {
		if (!name.trim() || !email.trim() || !message.trim()) {
			toast.error('All fields are required.');
			return false;
		}

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			toast.error('Please enter a valid email address.');
			return false;
		}

		return true;
	};

	const handleChangeInput = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleSubmit = () => {
		const isValid = validateForm();

		if (isValid) {
			setLoading(true);

			const contact = {
				_type: 'contact',
				name,
				email,
				message,
			};

			client
				.create(contact)
				.then(() => {
					setLoading(false);
					setIsFormSubmitted(true);
					toast.success('Message sent successfully!');
				})
				.catch((err) => {
					console.error(err);
					setLoading(false);
					toast.error('Error sending message. Please try again.');
				});
		}
	};

	return (
		<>
			<ToastContainer />
			<h2 className='head-text'>Take a coffee & chat with me</h2>

			<div className='app__footer-cards'>
				<div className='app__footer-card '>
					<img src={images.email} alt='email' />
					<a href='mailto:rakibhasansohag133@gmail.com' className='p-text'>
						rakibhasansohag133@gmail.com
					</a>
				</div>
				<div className='app__footer-card'>
					<img src={images.mobile} alt='phone' />
					<a href='tel:+880 176016 9982' className='p-text'>
						+880 176016 9982
					</a>
				</div>
			</div>
			{/* // point : form submitting section */}
			{!isFormSubmitted ? (
				<div className='app__footer-form app__flex'>
					<div className='app__flex'>
						<input
							className='p-text'
							type='text'
							placeholder='Your Name'
							name='name'
							value={name}
							onChange={handleChangeInput}
						/>
					</div>
					<div className='app__flex'>
						<input
							className='p-text'
							type='email'
							placeholder='Your Email'
							name='email'
							value={email}
							onChange={handleChangeInput}
						/>
					</div>
					<div>
						<textarea
							className='p-text'
							placeholder='Your Message'
							value={message}
							name='message'
							onChange={handleChangeInput}
						/>
					</div>
					<button type='button' className='p-text' onClick={handleSubmit}>
						{!loading ? 'Send Message' : 'Sending...'}
					</button>
				</div>
			) : (
				<div>
					<h3 className='head-text'>Thank you for getting in touch With Me!</h3>
				</div>
			)}
			<ToastContainer />
		</>
	);
};

export default AppWrap(
	MotionWrap(Footer, 'app__footer'),
	'contact',
	'app__whitebg',
);
